<template>
    <div class="btn-group">
        <button v-if="prevButton && prevTab" type="button" accesskey="g" :disabled="!prevTab" @click="goPrevTab()" class="btn btn-primary" v-html="translate('previous')"></button>
        <button v-if="nextButton && nextTab" type="button" accesskey="l" :disabled="pageAlert" @click="goNextTab()" class="btn btn-primary" v-html="translate('next')"></button>
    </div>
</template>
<script>
export default {
    props: {
        tabs: {
            type: Array,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        prevButton: {
            type: Boolean,
            default: true
        },
        nextButton: {
            type: Boolean,
            default: true
        },
        saveOnNext: {
            type: Boolean,
            default: false,
        },
        pageAlert:{
            type: Boolean,
            default: false,
        }
    },
    computed: {
        currentTab(){
            return this.tabs.filter(x => x.key == this.value)[0];
        },
        tabIndex(){
            return this.tabs.indexOf(this.currentTab) || 0;
        },
        nextTab(){
            for(var i = this.tabIndex + 1; i < this.tabs.length; i++) {
                var tab = this.tabs[i];
                if(tab && (tab.visible == undefined || tab.visible())) {
                    return tab;
                }
            }

            return null;
        },
        prevTab(){
            for(var i = this.tabIndex - 1; i >= 0; i--) {
                var tab = this.tabs[i];
                if(tab && (tab.visible == undefined || tab.visible())) {
                    return tab;
                }
            }

            return null;
        }
    },
    methods: {
        goTab(key){
            this.$emit('input', key);
            this.$emit('change', this.currentTab);
        },
        goNextTab(){
            if(this.nextTab)
            {
                if(this.saveOnNext){
                    this.$emit('saveOnNext')
                }
                this.$emit('input', this.nextTab.key);
                this.$emit('change', this.currentTab);
            }
        },
        goPrevTab() {
            if(this.prevTab)
            {
                this.$emit('input', this.prevTab.key);
                this.$emit('change', this.currentTab);
            }
        }
    }
}
</script>
